import React from "react";
import { Flex, Tabs, Typography } from "antd";
import "../userfiles-sessionhistory.scss";
import { useLocation } from "react-router-dom";
import {
  UserFilesTabsProvider,
  useUserFilesTabs,
} from "./UserFilesTabsContext";
import TabsTable from "./tabs-table";

function SingleUserFilesContent() {
  const { activeTab, setActiveTab } = useUserFilesTabs();
  const { Text } = Typography;
  const location = useLocation();

  const decodedCompanyName = decodeURIComponent(
    location.pathname.split("/")[2] ?? "-",
  );
  const clientId = location.pathname.split("/")[3];

  const [sessionType, setSessionType] = React.useState<
    "all" | "booking" | "tawk_chat"
  >("all");

  const tabItems = [
    {
      label: "Session Reports",
      key: "session_report",
      children:
        activeTab === "session_report" ? (
          <TabsTable title="Session Reports" sessionType={sessionType} />
        ) : null,
    },
    {
      label: "Takeaway Resources",
      key: "takeaway_resource",
      children:
        activeTab === "takeaway_resource" ? (
          <TabsTable sessionType={sessionType} title="Takeaway Resources" />
        ) : null,
    },
    {
      label: "Amber Records",
      key: "amber_records",
      children:
        activeTab === "amber_records" ? (
          <TabsTable sessionType={sessionType} title="Amber Records" />
        ) : null,
    },
    {
      label: "Goals in Therapy",
      key: "therapy_goals",
      children:
        activeTab === "therapy_goals" ? (
          <TabsTable sessionType={sessionType} title="Goals in Therapy" />
        ) : null,
    },

    {
      label: "Session Notes (Notepad)",
      key: "session_notes",
      children:
        activeTab === "session_notes" ? (
          <TabsTable sessionType={sessionType} title="Session Notes (Notepad)" />
        ) : null,
    },
    {
      label: "Crisis Window (Coming Soon)",
      key: "crisis",
      disabled: true,
    },
  ];

  return (
    <div className="singleUserFiles">
      <Flex vertical gap={4}>
        <Text className="companyName">
          {decodedCompanyName} &gt; {clientId}
        </Text>
        <Text className="title24">User Files & Sessions History</Text>
      </Flex>
      <div className="value_of_value">
        <p className="type-lbl">Session Type</p>
        <div className="">
          <div>
            <button
              className={`type-pill ${sessionType === "all" ? "active" : ""}`}
              onClick={() => setSessionType("all")}
            >
              All
            </button>

            <button
              className={`type-pill ${sessionType === "booking" ? "active" : ""}`}
              onClick={() => setSessionType("booking")}
            >
              Counseling
            </button>

            <button
              className={`type-pill ${sessionType === "tawk_chat" ? "active" : ""}`}
              onClick={() => setSessionType("tawk_chat")}
            >
              Chat (Tawk)
            </button>
          </div>
        </div>
      </div>
      <Tabs
        activeKey={activeTab}
        onChange={setActiveTab}
        
        className="userFilesTabs"
        type="card"
        items={tabItems}
      />
    </div>
  );
}

export default function SingleUserFiles() {
  return (
    <UserFilesTabsProvider>
      <SingleUserFilesContent />
    </UserFilesTabsProvider>
  );
}
